export const TASK_TYPES = {
    WEBSITE_MAPPING: 'Website Mapping',
    UI_SCAN: 'UI Scan',
    SCAN: 'scan',
    TEST_CASE_DISCOVERY: 'Test Case Discovery',
    LOGIN_TEST: 'Login Test',
    PAGE_TREE_SCAN: 'Page Tree Scan',
    LOGIN_ELEMENTS_PROCESSING: 'Login Elements Processing',
}

export const TASK_ALIAS_TYPES = {
    SITEMAP: "sitemap",
    SUBTREE: "subtree",
    SCAN: "scan",
    LOGIN_ELEMENTS: "loginElements",
    TEST_LOGIN: "testLogin",
    CLUSTERIZATION: "clusterization",
    TEST_CASE: "testCase",
    DISCOVER_TEST_CASES: "discoverTestCases",
    RE_LOGIN: "reLogin",
}

export const TASK_STATUSES = {
    PENDING: 'pending',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed',
    FAILED: 'failed',
    STOPPED: 'stopped'
}